/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
tinymce.addI18n('ru_RU', {
  Cut: '\u0412\u044b\u0440\u0435\u0437\u0430\u0442\u044c',
  'Heading 5': '\u0417\u0430\u0433\u043b\u0430\u0432\u0438\u0435 5',
  'Header 2': '\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 2',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": '\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043d\u0435 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u043f\u0440\u044f\u043c\u043e\u0439 \u0434\u043e\u0441\u0442\u0443\u043f \u043a \u0431\u0443\u0444\u0435\u0440\u0443 \u043e\u0431\u043c\u0435\u043d\u0430. \u0418\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435, \u043f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430,  Ctrl+X/C/V  \u043d\u0430 \u043a\u043b\u0430\u0432\u0438\u0430\u0442\u0443\u0440\u0435.',
  'Heading 4': '\u0417\u0430\u0433\u043b\u0430\u0432\u0438\u0435 4',
  Div: 'Div',
  'Heading 2': '\u0417\u0430\u0433\u043b\u0430\u0432\u0438\u0435 2',
  Paste: '\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c',
  Close: '\u0417\u0430\u043a\u0440\u044b\u0442\u044c',
  'Font Family': '\u0428\u0440\u0438\u0444\u0442',
  Pre: 'Pre',
  'Align right': '\u0412\u044b\u0440\u0430\u0432\u043d\u0438\u0432\u0430\u043d\u0438\u0435 \u0441\u043f\u0440\u0430\u0432\u0430',
  'New document': '\u041d\u043e\u0432\u044b\u0439 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442',
  Blockquote: 'Blockquote',
  'Numbered list': '\u041d\u0443\u043c\u0435\u0440\u043e\u0432\u0430\u043d\u043d\u044b\u0439 \u0441\u043f\u0438\u0441\u043e\u043a',
  'Heading 1': '\u0417\u0430\u0433\u043b\u0430\u0432\u0438\u0435 1',
  Headings: '\u0417\u0430\u0433\u043b\u0430\u0432\u0438\u0435',
  'Increase indent': '\u0423\u0432\u0435\u043b\u0438\u0447\u0438\u0442\u044c \u043e\u0442\u0441\u0442\u0443\u043f',
  Formats: '\u0424\u043e\u0440\u043c\u0430\u0442\u044b',
  Headers: '\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043a\u0438',
  'Select all': '\u0412\u044b\u0431\u0440\u0430\u0442\u044c \u0432\u0441\u0451',
  'Header 3': '\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 3',
  Blocks: 'Blocks',
  Undo: '\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c',
  Strikethrough: '\u0417\u0430\u0447\u0435\u0440\u043a\u043d\u0443\u0442\u044b\u0439',
  'Bullet list': '\u041c\u0430\u0440\u043a\u0438\u0440\u043e\u0432\u0430\u043d\u043d\u044b\u0439 \u0441\u043f\u0438\u0441\u043e\u043a',
  'Header 1': '\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 1',
  Superscript: '\u0421\u0443\u043f\u0435\u0440\u0441\u043a\u0440\u0438\u043f\u0442',
  'Clear formatting': '\u041e\u0447\u0438\u0441\u0442\u0438\u0442\u044c \u0444\u043e\u0440\u043c\u0430\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435',
  'Font Sizes': '\u0420\u0430\u0437\u043c\u0435\u0440\u044b \u0448\u0440\u0438\u0444\u0442\u043e\u0432',
  Subscript: '\u041f\u043e\u0434\u0441\u043a\u0440\u0438\u043f\u0442',
  'Header 6': '\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 6',
  Redo: '\u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u044c',
  Paragraph: 'Paragraph',
  Ok: '\u043e\u043a',
  Bold: '\u0416\u0438\u0440\u043d\u044b\u0439',
  Code: 'Code',
  Italic: '\u041a\u0443\u0440\u0441\u0438\u0432',
  'Align center': '\u0412\u044b\u0440\u0430\u0432\u043d\u0438\u0432\u0430\u043d\u0438\u0435 \u043f\u043e-\u0446\u0435\u043d\u0442\u0440\u0443',
  'Header 5': '\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 5',
  'Heading 6': '\u0417\u0430\u0433\u043b\u0430\u0432\u0438\u0435 6',
  'Heading 3': '\u0417\u0430\u0433\u043b\u0430\u0432\u0438\u0435 3',
  'Decrease indent': '\u0423\u043c\u0435\u043d\u044c\u0448\u0438\u0442\u044c \u043e\u0442\u0441\u0442\u0443\u043f',
  'Header 4': '\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 4',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.': '\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u043a\u0430\u043a \u0447\u0438\u0441\u0442\u044b\u0439 \u0442\u0435\u043a\u0441\u0442. \u0421\u043e\u0434\u0435\u0440\u0436\u0438\u043c\u043e\u0435 \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u0441\u044f \u043a\u0430\u043a \u0442\u0435\u043a\u0441\u0442, \u0434\u043e \u0442\u0435\u0445 \u043f\u043e\u0440, \u043f\u043e\u043a\u0430 \u0432\u043a\u043b\u044e\u0447\u0435\u043d\u0430 \u044d\u0442\u0430 \u043e\u043f\u0446\u0438\u044f',
  Underline: '\u041f\u043e\u0434\u0447\u0435\u0440\u043a\u043d\u0443\u0442\u044b\u0439',
  Cancel: '\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c',
  Justify: '\u0412\u044b\u0440\u0430\u0432\u043d\u0438\u0432\u0430\u043d\u0438\u0435 \u043f\u043e \u0448\u0438\u0440\u0438\u043d\u0435',
  Inline: 'Inline',
  Copy: '\u041a\u043e\u043f\u0438\u0440\u043e\u0432\u0430\u0442\u044c',
  'Align left': '\u0412\u044b\u0440\u0430\u0432\u043d\u0438\u0432\u0430\u043d\u0438\u0435 \u0441\u043b\u0435\u0432\u0430',
  'Visual aids': '\u0412\u0438\u0437\u0443\u0430\u043b\u044c\u043d\u044b\u0435 \u044d\u043b\u0435\u043c\u0435\u043d\u0442\u044b'
});